import { render, staticRenderFns } from "./TextAreaSettings.vue?vue&type=template&id=004c0b60&"
import script from "./TextAreaSettings.vue?vue&type=script&lang=js&"
export * from "./TextAreaSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports